/**
 * Ordered logo sets used by the DCL marketing sections.
 * Translation: Ordered logo sets used by the DCL marketing sections.
 */
export const peSponsorLogos = [
  { key: "centerbridge", label: "Centerbridge" },
  { key: "morganStanley", label: "Morgan Stanley" },
  { key: "norfolkSouthern", label: "Norfolk Southern" },
  { key: "thomaBravo", label: "Thoma Bravo" },
  { key: "blackRock", label: "BlackRock" },
];


export const teamLogoMarquee = [
  { key: "nasa", label: "NASA" },
  { key: "generalDynamics", label: "General Dynamics" },
  { key: "dod", label: "DOD" },
  { key: "visa", label: "Visa" },
  { key: "paypal", label: "PayPal" },
  { key: "ebay", label: "eBay" },
  { key: "blackRock", label: "BlackRock" },
];
